import { Guid } from "@/types";
import { TenantWarehouseLabelData } from 'models/TenantWarehouse';
import ProfitCenter from './ProfitCenter';

export interface ICollectiveReferenceNumberDto {
    warehouseId?: Guid | null
    profitCenterId?: Guid | null
    referenceNumberSale: string
    referenceNumberRental: string
}

export default class CollectiveReferenceNumber {

    warehouseId?: Guid | null
    profitCenterId?: Guid | null
    warehouseName?: string | null
    profitCenterName?: string | null
    referenceNumberSale: string
    referenceNumberRental: string

    constructor({ warehouseId, profitCenterId, referenceNumberSale, referenceNumberRental }: ICollectiveReferenceNumberDto) {
        this.profitCenterId = profitCenterId
        this.warehouseId = warehouseId
        this.referenceNumberSale = referenceNumberSale
        this.referenceNumberRental = referenceNumberRental
    }


    addWarehouseName(warehouses: TenantWarehouseLabelData[]) {
        this.warehouseName = warehouses.find(warehouse => warehouse.id === this.warehouseId)?.description
    }

    addProfitCenterName(profitCenters: ProfitCenter[]) {
        this.profitCenterName = profitCenters.find(profitCenter => profitCenter.id === this.profitCenterId)?.description
    }
}
